<template>
<div class="portfolio-table__wrapper">
    <table class="table">
        <PortfolioHeader @sortOn="sortOn"/>
        <tbody class="tbody">
            <PortfolioRow
                v-for="(rowData, i) of sortedPfRows"
                :key="`row_${i}`"
                :rowData="rowData"
            />
            <PortfolioTotalsRow
                :groupedCoinsByGeckoId="groupedCoinsByGeckoId"
            />
        </tbody>
    </table>
</div>
</template>

<script>
import PortfolioHeader from '@/components/portfolio/PortfolioHeader'
import PortfolioRow from '@/components/PortfolioRow'
import PortfolioTotalsRow from '@/components/portfolio/PortfolioTotalsRow'

export default {
    components: { PortfolioHeader, PortfolioRow, PortfolioTotalsRow },
    props:{
        groupedCoinsByGeckoId: Object,
    },
    data(){
        return{
            sortBy: null, // { column, direction }
        }
    },
    computed:{
        pfRows(){
            return Object.values(this.groupedCoinsByGeckoId)
        },
        sortedPfRows(){
            if(!this.sortBy){
                return this.pfRows
            }
            return this.pfRows.slice().sort((a, b) => {
                if(a[this.sortBy.column] < b[this.sortBy.column]){
                    return this.sortBy.direction === 'ASC' ? -1 : 1;
                }
                if (a[this.sortBy.column] > b[this.sortBy.column]){
                    return this.sortBy.direction === 'ASC' ? 1 : -1;
                }
                return 0;
            })
        },
    },
    methods:{
        sortOn(columnName){
            this.sortBy = this.getSortBy(columnName)
        },
        getSortBy(columnName){
            if(this.sortBy == null || this.sortBy.column != columnName){
                return {
                    column: columnName,
                    direction: 'DESC'
                }
            }
            if(this.sortBy.column == columnName && this.sortBy.direction == 'DESC'){
                return {
                    column: columnName,
                    direction: 'ASC'
                }
            }
            this.sortBy = null
        },
    }
}
</script>